import { Injectable } from '@angular/core';

@Injectable()

//  This class is required for getting the all the languages.
export class Languages {
    public allLanguages = [
        'Afrikaans',

        'Albanian',

        'Amharic',

        'Arabic',

        'Armenian',

        'Assamese',

        'Azeri',

        'Basque',

        'Belarusian',

        'Bengali',

        'Bosnian',

        'Bulgarian',

        'Burmese',

        'Cantonese',

        'Catalan',

        'Chinese',

        'Croatian',

        'Czech',

        'Danish',

        'Divehi',

        'Dutch',

        'Estonian',

        'Faroese',

        'Farsi',

        'Finnish',

        'Gaelic',

        'Galician',

        'Georgian',

        'German',

        'Greek',

        'Guarani',

        'Gujarati',

        'Hebrew',

        'Hindi',

        'Hungarian',

        'Icelandic',

        'Indonesian',

        'Italian',

        'Japanese',

        'Kannada',

        'Kashmiri',

        'Kazakh',

        'Khmer',

        'Korean',

        'Lao',

        'Latvian',

        'Lithuanian',

        'Macedonian',

        'Malay',

        'Malayalam',

        'Maltese',

        'Mandarin',

        'Maori',

        'Marathi',

        'Mongolian',

        'Nepali',

        'Norwegian',

        'Oriya',

        'Other',

        'Polish',

        'Portuguese',

        'Punjabi',

        'Romanian',

        'Russian',

        'Serbian',

        'Serbo - Croatian',

        'Sinhala',

        'Slovak',

        'Slovenian',

        'Somali',

        'Sorbian',

        'Spanish',

        'Swahili',

        'Swedish',

        'Tamil',

        'Tatar',

        'Telugu',

        'Thai',

        'Tibetan',

        'Tsonga',

        'Turkish',

        'Turkmen',

        'Ukrainian',

        'Urdu',

        'Vietnamese',

        'Welsh',

        'Xhosa',

        'Zulu'
    ];
}
